export function debounce(fn, time) {
	let timeoutId;
	let pendingContext;
	let pendingArgs;
	const invoke = () => {
		const context = pendingContext;
		const args = pendingArgs;
		timeoutId = undefined;
		pendingContext = undefined;
		pendingArgs = undefined;
		return fn.apply(context, args);
	};
	const debounced = function () {
		if (timeoutId) {
			clearTimeout(timeoutId);
		}
		pendingContext = this;
		pendingArgs = arguments;
		timeoutId = setTimeout(invoke, time);
	};
	debounced.cancel = () => {
		if (timeoutId) clearTimeout(timeoutId);
		timeoutId = undefined;
		pendingContext = undefined;
		pendingArgs = undefined;
	};
	debounced.flush = () => {
		if (!timeoutId) return;
		clearTimeout(timeoutId);
		invoke();
	};
	return debounced;
}
